import { ResizeObserver } from '@juggle/resize-observer';

// This polyfills ResizeObserver for browsers like iOS Safari so things like useMeasure will work.
if (typeof window !== 'undefined' && typeof (window as any).ResizeObserver === 'undefined') {
  (window as any).ResizeObserver = ResizeObserver;
}
